// Angular imports
import { Component, EventEmitter, Input, Output } from '@angular/core';

// CC-Common imports
import { IconConstants } from 'cc-common';

// Devextream imports
import { Column } from 'devextreme/ui/data_grid';

@Component({
    selector: 'app-search-transaction-log',
    templateUrl: './search-transaction-log.component.html',
    styleUrls: ['./search-transaction-log.component.scss']
})
export class SearchTransactionLogComponent {
    @Input() visible = false;
    @Input() logId: number;
    @Input() communityId: number;
    @Input() transactionLogData: any[] = [];
    @Input() columnDef: Column[] = [];
    @Output() onCloseClick = new EventEmitter<boolean>();

    iconClose = IconConstants.CLOSE;

    onPopClose(): void {
        this.visible = false;
        this.onCloseClick.emit(false);
    }
}
